import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { SharedModule } from '../../shared/shared.module';

import { CaptureComponent } from './capture/capture.component';
import { ProductsComponent } from './products.component';
import { OtherInformationComponent } from './other-information/other-information.component';
import { ConstructionComponent } from './other-information/construction/construction.component';
import { OtherInfosComponent } from './other-information/other-infos/other-infos.component';
import { DocumentationComponent } from './other-information/documentation/documentation.component';
import { ProductsFiltersComponent } from './products-filters/products-filters.component';
import { ProductCharacteristicsComponent } from './product-characteristics/product-characteristics.component';
import { NzDatePickerModule } from 'ng-zorro-antd';
import { MatSliderModule } from '@angular/material/slider';
import { GeneralFiltersComponent } from './products-filters/general-filters/general-filters.component';
import { CompanyFiltersComponent } from './products-filters/company-filters/company-filters.component';
import { ValueFiltersComponent } from './products-filters/value-filters/value-filters.component';
import { AddressFiltersComponent } from './products-filters/address-filters/address-filters.component';
import { OtherFiltersComponent } from './products-filters/other-filters/other-filters.component';
import { DateFiltersComponent } from './products-filters/date-filters/date-filters.component';
import { FeatureFiltersComponent } from './products-filters/feature-filters/feature-filters.component';
import { NeighborhoodFiltersComponent } from './products-filters/neighborhood-filters/neighborhood-filters.component';
import { ValueZoneFiltersComponent } from './products-filters/value-zone-filters/value-zone-filters.component';
import { RangeSelectorComponent } from '../../shared/components/range-selector/range-selector.component';

import { DescriptionComponent } from './description/description.component';
import { MediaComponent } from './media/media.component';
import { ProfessionalComponent } from './professional/professional.component';

@NgModule({
  declarations: [
    ProductsComponent,
    CaptureComponent,
    OtherInformationComponent,
    ConstructionComponent,
    OtherInfosComponent,
    DocumentationComponent,
    ProductsFiltersComponent,
    ProductCharacteristicsComponent,
    GeneralFiltersComponent,
    CompanyFiltersComponent,
    ValueFiltersComponent,
    AddressFiltersComponent,
    OtherFiltersComponent,
    DateFiltersComponent,
    FeatureFiltersComponent,
    NeighborhoodFiltersComponent,
    ValueZoneFiltersComponent,
    ProductCharacteristicsComponent,
    DescriptionComponent,
    MediaComponent,
    ProfessionalComponent
  ],
  imports: [
    SharedModule,
    RouterModule,
    NzDatePickerModule,
    MatSliderModule
  ],
  exports: [
    ProductsComponent,
    CaptureComponent,
    OtherInformationComponent,
    ConstructionComponent,
    OtherInfosComponent,
    DocumentationComponent,
    ProductCharacteristicsComponent,
    ProductsFiltersComponent,
    GeneralFiltersComponent,
    CompanyFiltersComponent,
    ValueFiltersComponent,
    AddressFiltersComponent,
    OtherFiltersComponent,
    DateFiltersComponent,
    FeatureFiltersComponent,
    NeighborhoodFiltersComponent,
    ValueZoneFiltersComponent
  ]
})
export class ProductsModule { }
